import { render, staticRenderFns } from "./module.glob.footer.vue?vue&type=template&id=2a01f12c&"
import script from "./module.glob.footer.vue?vue&type=script&lang=js&"
export * from "./module.glob.footer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports